<template>
  <div class="content">
    <div class="row">
      <div class="col-md-3">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="artistName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getData(1)" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left"></h4>
        <base-radio name="all" inline v-model="viewType">전체보기</base-radio>
        <base-radio name="merge" inline v-model="viewType">모아보기</base-radio>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="addArtistSuggestionForm" type="default">추가</base-button>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-sm-12">
            <base-radio @change="getData(1)" name="1" inline v-model="isVisible">표시</base-radio>
            <base-radio @change="getData(1)" name="0" inline v-model="isVisible">숨김</base-radio>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <h4 class="card-title text-left">등록마감시간</h4>
          <base-input placeholder="등록시간">
            <el-date-picker type="datetime" placeholder="등록마감시간" v-model="suggestionEndTime"></el-date-picker>
          </base-input>

          <base-button @click="setSuggestionEndTime(suggestionEndTime)" type="default">등록</base-button>
          <base-button @click="setSuggestionEndTime(null)" type="default">삭제</base-button>
        </div>
      </div>
    </div>
    <div v-if="viewType === 'all'" class="row">
      <el-table :span-method="objectSpanMethod" :data="data">
        <el-table-column :min-width="50" align="center" label="아이디">
          <div slot-scope="props">
            {{ props.row.id }}
          </div>
        </el-table-column>
        <el-table-column :min-width="70" align="center" label="아티스트명">
          <div slot-scope="props">
            <base-input placeholder="아티스트명" v-model="props.row.name">
              <span slot="helpBlock" class="form-text"></span>
            </base-input>
          </div>
        </el-table-column>
        <el-table-column :min-width="70" align="center" label="이메일">
          <div slot-scope="props">
            <base-input placeholder="이메일" v-model="props.row.email">
              <span slot="helpBlock" class="form-text"></span>
            </base-input>
          </div>
        </el-table-column>
        <el-table-column :min-width="100" align="center" label="설명">
          <div slot-scope="props">
            <base-input placeholder="설명" v-model="props.row.description">
              <span slot="helpBlock" class="form-text"></span>
            </base-input>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="등록일">
          <div slot-scope="props">
            {{ props.row.regDate }}
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="저장">
          <div slot-scope="props">
            <base-button @click.native="setArtistSuggestion(props.row)" type="warning" size="sm" icon>
              <i class="tim-icons icon-pin" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="삭제">
          <div slot-scope="props">
            <base-button @click.native="removeArtistSuggestion(props)" type="warning" size="sm" icon>
              <i class="tim-icons icon-simple-delete" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="숨김">
          <div slot-scope="props">
            <base-button v-if="isVisible === '1'" @click.native="hideArtist(props.row.name)" type="warning" size="sm" icon>
              <i class="tim-icons icon-simple-delete" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="viewType === 'all'" class="row">
      <base-pagination class="pagination-no-border" v-model="currentPageAll" :pageCount="totalPagesAll" />
    </div>
    <div v-if="viewType === 'merge'" class="row">
      <el-table :span-method="objectSpanMethod" :data="mergeData">
        <el-table-column :min-width="30" align="center" label="순위">
          <div slot-scope="props">
            {{ props.row.rank }}
          </div>
        </el-table-column>
        <el-table-column :min-width="70" align="center" label="아티스트명">
          <div slot-scope="props">
            {{ props.row.name }}
          </div>
        </el-table-column>
        <el-table-column :min-width="70" align="center" label="요청횟수">
          <div slot-scope="props">
            {{ props.row.count }}
          </div>
        </el-table-column>
        <el-table-column :min-width="70" align="center" label="이미지">
          <div slot-scope="props">
            <BlipFileUploadZone
              :upload-category="1"
              :index="props.row.index"
              :maxFiles="1"
              :fileUrl="props.row.imageFileUrl"
              @onChangeFileIds="onFileIdChange"
            />
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="저장">
          <div slot-scope="props">
            <base-button @click.native="setArtistSuggestionMetadata(props.row)" type="warning" size="sm" icon>
              <i class="tim-icons icon-pin" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="이메일">
          <div slot-scope="props">
            <base-button @click.native="showEmail(props.row.email)" type="warning" size="sm" icon>
              <i class="tim-icons icon-paper" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="숨김">
          <div slot-scope="props">
            <base-button v-if="isVisible === '1'" @click.native="hideArtist(props.row.name)" type="warning" size="sm" icon>
              <i class="tim-icons icon-simple-delete" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="viewType === 'merge'" class="row">
      <base-pagination class="pagination-no-border" v-model="currentPageMerge" :pageCount="totalPagesMerge" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import { URLUtils } from "@/util/URLUtils";
import swal from "sweetalert2";
import BlipFileUploadZone from "@/components/BlipFileUploadZone.vue";

export default {
  components: {
    BlipFileUploadZone,
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.artistName) {
        this.artistName = this.$route.query.artistName;
      }
    }
    await this.getData(1);
    await this.getSuggestionEndTime();
  },
  data() {
    return {
      artistName: null,
      data: [],
      mergeData: [],
      currentPageAll: 1,
      totalPagesAll: null,
      currentPageMerge: 1,
      totalPagesMerge: null,
      viewType: "all",
      isVisible: "1",
      suggestionEndTime: null,
    };
  },
  watch: {
    viewType: {
      handler() {
        this.getData(1);
      },
    },
    currentPageAll: {
      handler() {
        this.getData(this.currentPageAll);
      },
    },
    currentPageMerge: {
      handler() {
        this.getData(this.currentPageMerge);
      },
    },
    data: {
      handler() {
        this.getSpanArr(this.data);
      },
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
      //   const _row = this.spanArr[rowIndex];
      //   const _col = _row > 0 ? 1 : 0;
      //   return {
      //     rowspan: _row,
      //     colspan: _col
      //   };
      // }
    },
    rank(value, arr) {
      var sorted = arr.slice().sort(function (a, b) {
        return b - a;
      });
      var rank = sorted.indexOf(value);
      if (rank > -1) return rank + 1;
      return null;
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].userId === data[i - 1].userId) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    async getData(page) {
      const queryParams = {
        artistName: this.artistName,
      };
      // this.currentPageAll = page;
      this.currentPageMerge = page;
      const params = { name: this.artistName, isVisible: this.isVisible };
      params.currentPage = page ? page : 1;
      this.spanArr = [];

      const path = `/blipArtist/blipArtistSuggestion?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      await this.$axios.get("/artistUnit/suggestionCount", { params }).then((res) => {
        this.totalPagesMerge = Number(res.data.data.page);
        const counts = res.data.data.data.map((d) => d.count);
        this.mergeData = res.data.data.data.map((d, index) => {
          d.index = index;
          if (d.fileId) {
            d.imageFileUrl = window.Endpoints.imageServerUrl + d.fileId;
          }
          d.rank = this.rank(d.count, counts);
          return d;
        });
      });
      await this.$axios.get("/artistUnit/suggestion", { params }).then((res) => {
        this.data = res.data.data.data.map((d) => {
          d.regDate = formatDateTime(d.regTime, "YYYY-MM-DD");
          return d;
        });
        this.totalPagesAll = Number(res.data.data.page);
        this.searchedFilter = this.filterType;
      });
    },
    async setArtistSuggestion(row) {
      if (row.name === null || row.name === "" || row.name === undefined) {
        window.Toast.error("이름은 필수값입니다");
        return;
      }
      if (row.email === null || row.email === "" || row.email === undefined) {
        window.Toast.error("이메일은 필수값입니다");
        return;
      }
      if (row.description === null || row.description === "" || row.description === undefined) {
        row.description = "";
      }
      const params = {
        id: row.id,
        name: row.name,
        email: row.email,
        description: row.description,
      };
      return this.$axios.put("/artistUnit/suggestion", { params }).then((res) => {
        window.Toast.success("변경되었습니다");
      });
    },
    async setArtistSuggestionMetadata(row) {
      const params = {
        name: row.name,
        fileId: row.fileId,
      };
      return this.$axios.put("/artistUnit/suggestion/metadata", { params }).then((res) => {
        window.Toast.success("저장되었습니다");
      });
    },
    async hideArtist(name) {
      if (name) {
        swal
          .fire({
            title: "숨김 확인",
            text: `${name} 아티스트를 숨김 하시겠습니까?`,
            type: "warning",
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-danger btn-fill",
              cancelButton: "btn btn-cancel btn-fill",
            },
            confirmButtonText: "숨김",
            cancelButtonText: "취소",
            buttonsStyling: false,
          })
          .then(async (selection) => {
            if (selection.value) {
              const params = {
                name,
              };
              return this.$axios.delete("/artistUnit/suggestion/hide", { params }).then((res) => {
                window.Toast.success("숨겨졌어요");
                this.getData(1);
              });
            }
          });
      }
    },
    async removeArtistSuggestion(props) {
      if (props.row.id) {
        swal
          .fire({
            title: "삭제 확인",
            text: `${props.row.name} 제안 삭제하시겠습니까?`,
            type: "warning",
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-danger btn-fill",
              cancelButton: "btn btn-cancel btn-fill",
            },
            confirmButtonText: "삭제",
            cancelButtonText: "취소",
            buttonsStyling: false,
          })
          .then(async (selection) => {
            if (selection.value) {
              const row = props.row;
              const params = {
                id: row.id,
              };
              return this.$axios.delete("/artistUnit/suggestion", { params }).then((res) => {
                window.Toast.success("삭제되었습니다");
                this.data.splice(props.$index, 1);
              });
            }
          });
      } else {
        this.data.splice(props.$index, 1);
      }
    },
    async setSuggestionEndTime(time) {
      if (!this.suggestionEndTime || this.suggestionEndTime === "") {
        window.Toast.error("시간을 입력해주세요");
        return;
      }
      const title = time ? "마감시간 등록" : "마감시간 삭제";
      const text = time ? `마감시간을 등록하시겠습니까?` : `마감시간을 삭제하시겠습니까?`;
      const confirmButtonText = time ? `등록` : `삭제`;
      swal
        .fire({
          title: title,
          text: text,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: confirmButtonText,
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            return this.$axios.put("/common/config", { key: "ARTIST_SUGGESTION_END_TIME", value: time }).then((res) => {
              Toast.success(`${confirmButtonText}되었습니다`);
              this.getSuggestionEndTime();
            });
          }
        });
    },
    async getSuggestionEndTime() {
      const res = await this.$axios.get(`/common/config?key=ARTIST_SUGGESTION_END_TIME`);
      this.suggestionEndTime = res.data.data;
    },
    showEmail(email) {
      swal.fire({
        title: "이메일목록",
        text: `${email}`,
        type: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger btn-fill",
          cancelButton: "btn btn-cancel btn-fill",
        },
        confirmButtonText: "확인",
      });
    },
    onFileIdChange(newFileIds, index) {
      this.mergeData[index].fileId = newFileIds[0];
    },
    async addArtistSuggestionForm() {
      this.data.unshift({});
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
